import {
	ROUTE_NAMES_SOFTWARE_DEPLOYMENTS,
	ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC,
} from '@atlassian/jira-common-constants/src/spa-routes';
import { useRouteByName } from '@atlassian/jira-platform-router-utils';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import type { Route } from '@atlassian/jira-router';

export const useDeploymentsRoute = (): Route | string => {
	const { data: project } = useProjectContext();

	const routeName = project?.simplified
		? ROUTE_NAMES_SOFTWARE_DEPLOYMENTS
		: ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC;

	return useRouteByName(routeName) ?? routeName;
};
